import React, { useState, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import Button from 'react-bootstrap/Button';
import axios, { AxiosResponse } from 'axios'
import swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/core/Auth'
import { RefuseTrYosTransaction, ApproveTrYosTransaction } from '../../../pages/applicationuser/list/core/_requests';
import { getTRYOSYears } from '../../../pages/code/list/core/_requests';

const API_URL_REAL = process.env.REACT_APP_API_URL

export function Tryos() {

    interface ApplicantData {
        tcKimlikNo: string;
        ad: string;
        soyad: string;
        puan: number;
        tmDogru: number;
        syDogru: number;
        tmYanlis: number;
        syYanlis: number;
        basariSirasi: number;
        adaySayisi: number;
    }

    const { logout, currentUser, setCurrentUser } = useAuth();
    const [attended, setAttended] = useState(false);
    const [checkDisabled, setCheckDisabled] = useState(false);
    const [nextDisabled, setNextDisabled] = useState(false);
    const [generalDisabled, setGeneralDisabled] = useState(false);
    const [logoutt, setLogout] = useState(false);
    const intl = useIntl();
    const [tryosNumber, setTryosNumber] = useState("");
    const [point, setPoint] = useState("");
    const [applicantData, setApplicantData] = useState<ApplicantData | null>(null);
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);

    const updateTryosAttended = async (newValue: string, newValue2: string) => {
        return new Promise<void>((resolve, reject) => {
            if (currentUser?.id === undefined) {
                reject("User ID is undefined.");
                return;
            }

            const updatedUser = {
                ...currentUser,
                tryosAttended: newValue,
                trYosTransactionDone: newValue2
            };

            setCurrentUser(updatedUser);
            resolve();
        });
    };

    const handleLogout = async () => {
        setLogout(true)
    }

    const handleNotAttended = async () => {
        // Kullanıcı seçimini almak için bir modal kullanıyorsanız, bu kodu modal'daki bir düğmeye veya olaya bağlayın.

        swal.fire({
            title: intl.formatMessage({
                id: 'TRYOS_VARMI2'
            }),
            text: intl.formatMessage({ id: 'TRYOS_VARMI' }),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({ id: 'Yes' }),
            cancelButtonText: intl.formatMessage({ id: 'No' }),

        }).then(async (result) => {
            if (result.isConfirmed) {
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Swal_proces'
                    }),
                    text: intl.formatMessage({ id: 'Swall_wait' }),
                    icon: 'info',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                setGeneralDisabled(true)
                const response = await axios.post(`${API_URL_REAL}/Custom/UpdateTryosNotAttended`);
                if (response?.status == 200) {
                    await updateTryosAttended("0", "1")
                    await ApproveTrYosTransaction()
                    navigate('/exam/uploadid');
                    swal.close();
                }
            } else {
                swal.close(); // Modal'ı kapatmak için bu satırı ekleyin
            }
        });


    }

    const handleNext = async () => {
        const performUpdate = async () => {
            if (!file) {
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Error'
                    }),
                    text: intl.formatMessage({ id: 'Please upload your exam result document.' }),
                    icon: 'error',
                    confirmButtonText: intl.formatMessage({ id: 'Okay' })
                })
                return;
            }
            setNextDisabled(true)
            const formData = new FormData();
            formData.append('file', file);
            const response = await axios.post(`${API_URL_REAL}/Custom/UpdateUserFromTrYos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response?.status == 200) {
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Success'
                    }),
                    text: intl.formatMessage({ id: 'Update Is Succesful.' }),
                    icon: 'success',
                    confirmButtonText: intl.formatMessage({ id: 'Okay' })
                }).then(async (result) => {
                    if (result.isConfirmed) {
                    }
                })
                await updateTryosAttended("1", "1");
                ApproveTrYosTransaction()
                navigate('/exam/uploadid');
            } else {
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Error'
                    }),
                    text: intl.formatMessage({ id: 'Error_Massage' }),
                    icon: 'error',
                    confirmButtonText: intl.formatMessage({ id: 'Okay' })
                })
                setNextDisabled(false)
            }

        }
        performUpdate();
    }

    const handleFileChange = (e: any) => {
        const selected = e.target.files[0];
        const ALLOWED_TYPES = ["application/pdf"];

        if (selected && ALLOWED_TYPES.includes(selected.type)) {
            setFile(selected);
            setFileError("");
        } else {
            setFile(null);
            setFileError(intl.formatMessage({ id: 'Please select a valid file type (.pdf)' }));
        }
    };

    const handleYear = (e: any) => {
        setSelectedYear(e)
    }

    useEffect(() => {
        if (logoutt) {
            logout()
        }
        else {
            if (currentUser?.trYosTransactionDone === "1")
                navigate('/exam/uploadid');
        }

    }, [logoutt])

    useEffect(() => {
        getTRYOSYears().then((res: any) => {
       
            setYears(res)
        })

    }, [])



    const handleCheck = async () => {
        setCheckDisabled(true)
        try {
            // try {
            //     const response = await axios.post(`${API_URL_REAL}/Custom/CheckTrYosPoints?TCKIMLIKNO=${tryosNumber}&PUANIN=${point}`);
            //     setApplicantData(response.data);
            // } catch (error) {
            //     swal.fire({
            //         title: intl.formatMessage({
            //             id: 'Error'
            //         }),
            //         text: intl.formatMessage({ id: 'The information you have provided is invalid. Please check and try again.' }),
            //         icon: 'error',
            //         confirmButtonText: intl.formatMessage({ id: 'Okay' })
            //     })
            // }
            try {
                const response = await axios.post(`${API_URL_REAL}/Custom/CheckTrYosPoints?TCKIMLIKNO=${tryosNumber}&PUANIN=${point}&year=${selectedYear}`);
                setApplicantData(response.data);
            } catch (error: any) {
                if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message;
                    swal.fire({
                        title: intl.formatMessage({ id: 'Error' }),
                        text: intl.formatMessage({ id: errorMessage }),
                        icon: 'error',
                        confirmButtonText: intl.formatMessage({ id: 'Okay' })
                    })
                } else {
                    swal.fire({
                        title: intl.formatMessage({ id: 'Error' }),
                        text: intl.formatMessage({ id: 'The information you have provided is invalid. Please check and try again.' }),
                        icon: 'error',
                        confirmButtonText: intl.formatMessage({ id: 'Okay' })
                    })
                }
            }

        } catch (error) {
            //console.error('There was an error!', error);
        }
        setCheckDisabled(false)
    };
    return (
        <>
            {!applicantData && !attended &&
                <div className='row g-5 g-xxl-8 justify-content-center text-center'>
                    <div className='col-12'>
                        <Button disabled={generalDisabled} variant='primary' onClick={() => setAttended(true)}>
                            {intl.formatMessage({ id: 'I have TR-YÖS exam result' })}
                        </Button>
                    </div>
                    <div className='col-12'>
                        <Button disabled={generalDisabled} variant='secondary' onClick={() => handleNotAttended()}>
                            {intl.formatMessage({ id: 'I don\'t have TR-YÖS exam result' })}
                        </Button>
                    </div>
                </div>
            }

            {attended && !applicantData &&
                (
                    <>

                        <div className='row fv-row mt-10 mb-7 px-3'>
                            <div className='col-xl-12'>
                                <div className='fv-row mb-5'>
                                    <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'SinavYili' })}</label>
                                    <select
                                        // id={`preference${index}`}
                                        className="form-select"
                                        // value={selectedQuotas[index]?.id || ''}
                                        onChange={(e) => handleYear(String(e.target.value))}
                                    // disabled={(index > 0 && !selectedQuotas[index - 1]) || !statusForPreference}
                                    // Bir önceki tercih yapılmadan, mevcut tercih etkinleştirilmez.
                                    >
                                        <option value="">{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                        {years.map((pq: any) => (
                                            <option
                                                value={pq}
                                                key={pq}

                                            >
                                                {pq}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='row fv-row mb-7 px-3'>
                            <div className='col-xl-12'>
                                <div className='fv-row mb-5'>
                                    <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'TR-YÖS participate number' })}</label>
                                    <input
                                        placeholder={intl.formatMessage({ id: 'TR-YÖS participate number' })}
                                        type="text"
                                        value={tryosNumber}
                                        onChange={(e) => setTryosNumber(e.target.value)}
                                        className='form-control form-control-lg form-control-solid'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row fv-row px-3'>
                            <div className='col-xl-12'>
                                <div className='fv-row mb-5'>
                                    <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Exam Score for TR-YÖS' })}</label>
                                    <input
                                        placeholder={intl.formatMessage({ id: 'Exam Score' })}
                                        type="text"
                                        value={point}
                                        onKeyDown={(e: any) => {
                                            if (e.key === '.' && e.target.value.indexOf(',') === -1) { // Nokta tuşuna basıldığında ve virgül yoksa
                                                e.preventDefault(); // Noktanın varsayılan davranışını engelle
                                                const cursorPosition = e.target.selectionStart; // İmlecin konumunu al
                                                e.target.value = e.target.value.substring(0, cursorPosition) + ',' + e.target.value.substring(cursorPosition); // Noktayı imlecin bulunduğu konuma virgül olarak ekle
                                                e.target.setSelectionRange(cursorPosition + 1, cursorPosition + 1); // İmleci virgülün sağ tarafına konumlandır
                                            } else if (e.key === ',' && e.target.value.split(',').length > 1) { // Virgül tuşuna basıldığında ve virgül zaten varsa
                                                e.preventDefault(); // Virgülün varsayılan davranışını engelle
                                            }
                                        }}
                                        onInput={(e: any) => {
                                            e.target.value = e.target.value.replace(/[^0-9,]/g, ''); // Sadece rakamlar ve virgül kabul edilir
                                        }}
                                        onChange={(e) => setPoint(e.target.value)}
                                        className='form-control form-control-lg form-control-solid'
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            {applicantData && (
                <>
                    <h2>{intl.formatMessage({ id: 'TR-YÖS Applicant Information' })}</h2>
                    <div className="row mt-7 ">
                        <div className="col-12">
                            <p><strong>{intl.formatMessage({ id: 'Applicant No' })}:</strong> {applicantData.tcKimlikNo}</p>
                            <p><strong>{intl.formatMessage({ id: 'Name' })}:</strong> {applicantData.ad}</p>
                            <p><strong>{intl.formatMessage({ id: 'Surname' })}:</strong> {applicantData.soyad}</p>
                            <p><strong>{intl.formatMessage({ id: 'Exam Score' })}:</strong> {applicantData.puan}</p>
                        </div>
                    </div>
                    <div className="row mt-7">
                        <div className="col-12">
                            <p><strong>{intl.formatMessage({ id: 'Upload your exam result document' })} (PDF):</strong></p>
                            <input type="file" onChange={handleFileChange} accept=".pdf" />
                            {fileError && <p style={{ color: "red" }}>{fileError}</p>}
                        </div>
                    </div>
                </>
            )
            }

            {attended && !applicantData && <div className='row fv-row mt-7 justify-content-end'>
                <div className='col-xl-6 d-flex justify-content-end gap-2'>
                    <Button variant='primary' disabled={checkDisabled} onClick={() => setAttended(false)}>
                        {"< " + intl.formatMessage({ id: 'Back' })  }
                    </Button>
                    <Button variant='warning' disabled={checkDisabled} onClick={handleCheck}>
                        {intl.formatMessage({ id: 'Check' }) + " > "}
                    </Button>
                </div>
            </div>}

            {applicantData && <div className='row fv-row mt-7 justify-content-end'>
                <div className='col-xl-6 d-flex justify-content-end'>
                    <Button variant='success' disabled={nextDisabled} onClick={handleNext}>
                        {intl.formatMessage({ id: 'Next' }) + " > "}
                    </Button>
                </div>
            </div>}

            <div className='row fv-row mt-7 justify-content-end'>
                <div className='col-xl-6 d-flex justify-content-end'>
                    <Button disabled={generalDisabled} variant='danger' onClick={handleLogout}>
                        {intl.formatMessage({ id: 'Logout' })}
                    </Button>
                </div>
            </div>
        </>
    )
}
